import {Artifact} from "../../../../types";
import {PasteChip} from "../../../../components/PasteChip";
import {isPasteArtifact, readPasteChip} from "../../utils/pasteAttachments";

interface UserAttachmentRendererProps {
    artifact: Artifact;
}

/**
 * The card for an attachment the user sent. The answer can cite it as [aN], so
 * the reference needs something to land on — a chip that matches the one on the
 * user's message. Attachment kinds without a card of their own render nothing.
 */
export function UserAttachmentRenderer({
    artifact,
}: UserAttachmentRendererProps) {
    if (!isPasteArtifact(artifact)) return null;
    return <PasteChip {...readPasteChip(artifact)} preview />;
}
